const Star = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10.0003 14.3915L15.1503 17.4998L13.7837 11.6415L18.3337 7.69984L12.342 7.18317L10.0003 1.6665L7.65866 7.18317L1.66699 7.69984L6.20866 11.6415L4.85033 17.4998L10.0003 14.3915Z"
      fill="url(#paint0_linear_3486_34629)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3486_34629"
        x1="1.674"
        y1="9.63436"
        x2="18.3355"
        y2="9.63436"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#42E6FF" />
        <stop offset="1" stopColor="#8B5EF7" />
      </linearGradient>
    </defs>
  </svg>
);

export default Star;
